import IconBag from "../../../../../../../../assets/images/icon-big-acquisto-88-px.svg";
import IconTruck from "../../../../../../../../assets/images/icon-big-consegna-88-px.svg";
import IconPackage from "../../../../../../../../assets/images/icon-big-pack-88-px.svg";
import IconCoins from "../../../../../../../../assets/images/icon-big-coins-88-px.svg";
import IconCalendar from "../../../../../../../../assets/images/icon-big-calendar-88-px.svg";
import {Skeleton} from "@material-ui/lab";

export const cardData = (row, qtaConsegnata, deviceDetailsLoading) => ([
    {
        title: "qtà contrattualizzata",
        content: row.qtaContrattualizzata,
        image: IconBag
    },
    {
        title: "qtà consegnata",
        content: deviceDetailsLoading ? <Skeleton width='60px' variant='rect' height='30px'/> : qtaConsegnata,
        image: IconTruck
    },
    {title: "Tipo di vendita", content: row.tipoVendita, image: IconPackage},
    {title: "contributo inziale", content: row.contributoIniziale, image: IconCoins},
    {title: "Canone", content: row.canone, image: IconCoins},
    {title: "Numero Mesi", content: row.numeroMesi, image: IconCalendar}
])

export const sortingCriteriaConsegna = [
    {text: "Numero", value: "numero"}
];

export const sortingCriteriaConsegnati = [
    {text: "Imei", value: "imei"}
];
